import React, { memo } from 'react'
import GroupedViewInternal from './GroupViewInternal/GroupedViewInternal'
import { getAllColumns, getGroupedData, getVisibleFields, normalizeData } from './utils'
import './GroupViewStyle.css'
import { Paper, Table, TableContainer } from '@mui/material'

const MARGIN_PER_LEVEL = 10
const GROUPED_VIEW_FIELDS = {
  f_key: 'Grouped By',
  f_value: 'Group Value',
}

/* here data is subFields of table */
const GroupView = ({
  data,
  keyValuePairs,
  groupingFields,
  accumulatedFields = [],
  hiddenFields = [],
  fieldsForGroupView = GROUPED_VIEW_FIELDS,
  reviewData = {},
  normalizedDataForGroupView = null,
  previewCurrency,
}) => {
  const normalizedData = normalizedDataForGroupView
    ? normalizedDataForGroupView
    : normalizeData(data, keyValuePairs)

  const columnsMapping = Object.entries(normalizedDataForGroupView[0] || {}).reduce(
    (acc, [key, value]) => {
      return { ...acc, [key]: value.field_template_name }
    },
    {}
  )

  const visibleFields = getVisibleFields(
    groupingFields,
    fieldsForGroupView,
    columnsMapping,
    hiddenFields
  )

  const groupedData = getGroupedData(
    normalizedData,
    groupingFields,
    accumulatedFields,
    columnsMapping
  )
  return (
    <div className="grouped-view-wrapper2">
      <TableContainer component={Paper}>
        <Table stickyHeader aria-label="simple table">
          {groupedData.map((it, index) => {
            return (
              <GroupedViewInternal
                data={it}
                headingMap={visibleFields}
                marginPerLevel={MARGIN_PER_LEVEL}
                heading={index === 0}
                reviewData={reviewData}
                previewCurrency={previewCurrency}
              />
            )
          })}
        </Table>
      </TableContainer>
    </div>
  )
}

export default memo(GroupView)
